import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  container: {
    height: 'fit-content',
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '90%'
    },
    [theme.breakpoints.down('md')]: {
      margin: '0 1rem',
      width: '100%'
    }
  },
  gridItem: {
    padding: theme.spacing(0),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    }
  },
  nextButton: {
    padding: '1.25rem 2rem',
    textTransform: 'none',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1.25rem 0',
      width: '100%'
    }
  },
  downloadButton: {
    width: '100%',
    padding: '1rem 0',
    textTransform: 'none'
  },
  buttonRight: {
    float: 'right'
  },
  responsiveImage: {
    width: '100%',
    height: 'auto',
    maxWidth: '28.125rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '31.25rem'
    },
    borderStyle: 'solid',
    borderWidth: '1px 5px 5px 1px',
    borderRadius: '1rem'
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  caption: {
    textTransform: 'uppercase'
  },
  title: {
    marginBottom: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1rem'
    }
  },
  list: {
    paddingLeft: '1.4rem',
    marginTop: '0.375rem'
  },
  bottomSpacing: {
    marginBottom: '2rem !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5rem !important'
    }
  },
  userInputSpacing: {
    marginBottom: '0.375rem !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1.5rem !important'
    }
  },
  summaryCardContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('md')]: {
      maxWidth: '31.25rem'
    }
  },
  summaryCardContainer2Cols: {
    width: '100%',
    margin: '0 auto',
    maxWidth: '65rem',
    padding: '0 1rem'
  },
  summaryCardBottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& p': {
      marginBottom: '2.5rem',
      padding: '0'
    },
    '& button': {
      width: '100%',
      padding: '1.25rem 2rem',
      margin: '0 auto 2.5rem auto',
      [theme.breakpoints.up('md')]: {
        maxWidth: 'max-content'
      },
      '&:last-of-type': {
        margin: '0 0 2rem 0',
        alignSelf: 'flex-end'
      }
    }
  },
  summaryCard: {
    padding: '2rem',
    backgroundColor: ({ bgcolor }) => theme.palette[bgcolor]?.main,
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem'
    }
  },
  summaryCardTitle: {
    fontSize: '1.75rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem'
    }
  },
  summaryCardTextSpacing: {
    paddingBottom: '1.5rem'
  },
  summaryEmojiSpacing: {
    marginRight: '0.625rem'
  },
  summaryCardTwoColumns: {
    width: '100%',
    margin: '0 auto',
    maxWidth: '65rem',
    display: 'grid',
    '& > div:last-of-type': {
      gridColumnStart: '-1',
      gridColumnEnd: '1'
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr',
      columnGap: '2.5rem'
    }
  }
}));
